export const services = [
    {
        count: 1,
        title: `Pesawat Uap Bejana Tekan`,
        slug: 'pesawat-uap-bejana-tekan',
        icon: require('../images/icon/compass.png'),
        image: require('../images/services/pesawat-uap-dan-bejana-tekan.jpg'),
        description: 'Pemeriksaan dan pengujian bejana tekan serta pesawat uap sesuai standar keselamatan kerja.',
    },
    {
        count: 2,
        title: 'Pesawat Angkat & Angkut',
        slug: 'pesawat-angkat-angkut',
        icon: require('../images/icon/compass.png'),
        image: require('../images/services/pesawat-angkat-dan-angkut.jpg'),
        description: 'Inspeksi alat berat seperti forklift, crane, dan hoist untuk memastikan kelayakan operasional.',
    },
    {
        count: 3,
        title: 'Elevator & Escalator',
        slug: 'elevator-escalator',
        icon: require('../images/icon/compass.png'),
        image: require('../images/services/elevator-dan-escalator.jpg'),
        description: 'Pengujian dan inspeksi lift serta eskalator untuk menjamin keselamatan pengguna.',
    },
    {
        count: 4,
        title: 'Instalasi Listrik & Instalasi Penyalur Petir',
        slug: 'instalasi-listrik-penyalur-petir',
        icon: require('../images/icon/compass.png'),
        image: require('../images/services/instalasi-listrik-dan-penyalur-petir.jpg'),
        description: 'Pemeriksaan sistem kelistrikan dan penyalur petir untuk mencegah risiko kecelakaan kerja.',
    },
    {
        count: 5,
        title: 'Pesawat Tenaga Produksi',
        slug: 'pesawat-tenaga-produksi',
        icon: require('../images/icon/compass.png'),
        image: require('../images/services/pesawat-tenaga-dan-produksi.jpg'),
        description: 'Pengujian mesin-mesin produksi untuk mendukung operasional yang aman dan efisien.',
    },
    {
        count: 6,
        title: 'Instalasi Proteksi Kebakaran',
        slug: 'instalasi-proteksi-kebakaran',
        icon: require('../images/icon/compass.png'),
        image: require('../images/services/instalasi-proteksi-kebakaran.jpg'),
        description: 'Inspeksi sistem proteksi kebakaran seperti hydrant, alarm, dan sprinkler.',
    },
    {
        count: 7,
        title: 'Non Destructive Test (NDT)',
        slug: 'non-destructive-test',
        icon: require('../images/icon/compass.png'),
        image: require('../images/services/non-destructive-test.jpg'),
        description: 'Pengujian material tanpa merusak objek untuk mendeteksi cacat atau kerusakan tersembunyi.',
    }
];
